import styled from "styled-components";

export const MainWrapper = styled.div``;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 16px;
`;

export const InputAndLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1;
`;

export const TextInputWitWhiteBackGround = styled.input`
  border: 1px solid ${({ error }) => (error ? "#E6000F" : "#d3d6e080")};
  background: ${({ isDark }) => (isDark ? "#f3f4f6" : "white")};
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  color: #1f2937;
  border-radius: 4px;

  ::placeholder {
    color: #9ca3af;
  }
`;

export const CommonLabel = styled.label`
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  vertical-align: center;
`;

export const CheckBoxWrapperWithDarkBAckground = styled.div`
  border: ${({ error }) => (error ? "1px solid #E6000F" : "none")};
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f3f4f6;
  border-radius: 4px;
  width: 100%;

  ${CommonLabel} {
    line-height: 20px;
  }

  @media (max-width: 480px) {
    align-items: flex-start;
    padding: 14px;
    gap: 10px;

    input {
      margin-top: 2px;
    }

    ${CommonLabel} {
      font-size: 13px;
      line-height: 19px;
      min-width: 0;
    }
  }
`;

export const Checkbox = styled.input``;

export const InputRowWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  position: relative;
  flex: 1;
`;

export const SingleColumnWrapper = styled(InputRowWrapper)`
  @media (max-width: 855px) {
    flex-direction: column;
  }
`;

export const YesOrNoRadioWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 20px;
`;

export const RadioInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const RadioInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CheckBoxInputsInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CheckBoxInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const GeneralInput = styled.input`
  border: ${({ error }) => (error ? "1px solid #E6000F" : "none")};

  font-size: 14px;
  font-weight: 400;
  color: #1f2937;
  display: flex;
  flex-shrink: 0;

  ::placeholder {
    color: #9ca3af;
  }
`;

export const ErrorText = styled.span`
  color: #ff0000;
  font-size: 13px;
  font-weight: 400;
  opacity: ${({ error }) => (!error ? "0" : "initial")};
`;

export const ErrorAndInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomNavButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  margin-top: 32px;
`;

export const KycAndPepWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelAndInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
`;

export const AdditionalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
`;
export const AdditionalInfoHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const AdditionalInfoContentWrapper = styled.div`
  display: flex;
  align-items: center;

  padding: 0 16px;
`;

export const AdditionalInfoArrowButton = styled.div`
  border-left: 5.6px solid transparent;
  border-right: 5.6px solid transparent;
  width: 5.6px;
  border-top: 5px solid #b6bbc8;
  transform: ${({ opened }) => opened && "rotateX(180deg)"};
`;

export const DateWrapper = styled.div`
  display: flex;
  padding: 32px 8px 24px 16px;
  font-weight: bold;
`;

export const KycInfoDescTable = styled.td`
  border-left: 1px solid #e5e7eb;
  padding-right: 50px;
  list-style-position: inside;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
